<template>
  <transition-group name="toast-list" tag="div" class="sla-toast-container">
    <div
      v-for="item in visibleToasts"
      :key="item.id"
      class="sla-toast-item"
      :class="
        item.sla_type == 'response'
          ? 'border-response'
          : item.sla_type == 'resolution'
          ? 'border-resolution'
          : 'border-warning'
      "
    >
      <!-- Icon เตือน -->
      <div class="toast-icon">
        <v-icon
          :color="
            ['response', 'resolution'].includes(item.sla_type)
              ? 'error'
              : 'warning'
          "
        >
          mdi-alert-circle-outline
        </v-icon>
      </div>

      <!-- Room Image -->
      <img
        :src="item.chat_room_image || defaultAvatar"
        class="room-avatar"
        @error="onImageError(item, 'chat_room_image')"
      />

      <!-- Content -->
      <div class="toast-content">
        <div class="room-name">{{ item.chat_room_name || "Unknown Room" }}</div>
        <div class="badge-wrapper">
          <!-- 1. ตัว Badge แสดง Status -->
          <span
            class="sla-badge"
            :class="{
              'badge-response': item.sla_type === 'response',
              'badge-resolution': item.sla_type === 'resolution',
              'badge-warning': item.sla_type.includes('warning'),
            }"
          >
            {{ getSlaText(item.sla_type) }}
          </span>

          <!-- 2. แสดงเวลาคงเหลือ (Seconds before due) กรณีที่เป็น Warning -->
          <span
            v-if="item.seconds_before_due && item.sla_type.includes('warning')"
            class="due-time-text"
          >
            ({{ formatDueTime(item.seconds_before_due) }})
          </span>
        </div>
      </div>

      <!-- ปุ่มปิด manual -->
      <button class="close-btn" @click="removeToast(item.id)">×</button>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: "ToastAlertSla",
  data() {
    return {
      toasts: [],
      maxVisible: 5, // Default Fallback
      toastHeight: 70, // ความสูง Toast + Margin (px)
      defaultAvatar: require("@/assets/images/image.png"),
    };
  },
  computed: {
    // โชว์เฉพาะจำนวนที่ยัดลงหน้าจอพอดี (ไม่ล้นจอ)
    visibleToasts() {
      return this.toasts.slice(0, this.maxVisible);
    },
  },
  mounted() {
    this.calculateMaxVisible();
    window.addEventListener("resize", this.calculateMaxVisible);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateMaxVisible);
  },
  methods: {
    onImageError(item, key) {
      item[key] = null;
    },
    // 📐 คำนวณความสูงหน้าจออัตโนมัติ ไม่ให้ล้นจอ
    calculateMaxVisible() {
      const windowHeight = window.innerHeight;
      const availableHeight = windowHeight - 40; // เว้น Margin Top/Bottom 40px
      const count = Math.floor(availableHeight / this.toastHeight);
      this.maxVisible = Math.max(1, count); // อย่างน้อยต้องแสดง 1 อัน

      // ถ้าของเดิมเกิน Max ที่คำนวณใหม่ ให้ตัดอันล่างสุดทิ้ง
      if (this.toasts.length > this.maxVisible) {
        this.toasts = this.toasts.slice(0, this.maxVisible);
      }
    },

    // 🚀 Method สำหรับเรียกสร้าง Toast
    addToast(data) {
      const ref_id = Date.now() + Math.random();
      const newToast = { ref_id, ...data };

      // ดัน Toast ใหม่ขึ้น **บนสุด**
      this.toasts.unshift(newToast);

      // 🛑 ถ้าเกินจำนวนที่จอมองเห็น ให้ลบอันล่างสุด (เก่าสุด) ออกทันที
      if (this.toasts.length > this.maxVisible) {
        this.toasts.pop();
      }

      // ⏱️ Auto dismiss ใน 5 วินาที
      setTimeout(() => {
        this.removeToast(ref_id);
      }, 5000);
    },

    removeToast(ref_id) {
      this.toasts = this.toasts.filter((t) => t.ref_id !== ref_id);
    },

    // ฟังก์ชันแปลง seconds เป็นเวลาอ่านง่าย เช่น 300s -> "in 5m" หรือ "in 4m 30s"
    formatDueTime(seconds) {
      if (!seconds || seconds <= 0) return "due now";

      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;

      if (mins > 0 && secs > 0) return `in ${mins}m ${secs}s`;
      if (mins > 0) return `in ${mins}m`;
      return `in ${secs}s`;
    },

    // ข้อความสำหรับแสดงผล
    getSlaText(item) {
      const textMap = {
        response: "Response SLA Breached",
        resolution: "Resolution SLA Breached",
        response_warning: "Response SLA Warning",
        resolution_warning: "Resolution SLA Warning",
      };

      let text = textMap[item] || "";

      // ถ้าเลือกวิธีที่ 2 (เอาเวลารวมใน Badge)
      /*
    if (item.seconds_before_due && item.sla_type.includes('warning')) {
      text += ` (${this.formatDueTime(item.seconds_before_due)})`;
    }
    */

      return text;
    },
  },
};
</script>

<style scoped>
/* Container ลอยอยู่มุมขวาบน z-index สูงสุด */
.sla-toast-container {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none; /* เพื่อไม่ให้บังคลิกส่วนอื่น */
}

/* ตัวการ์ด Toast */
.sla-toast-item {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 320px;
  height: 80px;
  background: #ffffff;
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
}

.border-warning {
  border-left: 5px solid #ff9800;
}

.border-response {
  border-left: 5px solid #ff5722;
}

.border-resolution {
  border-left: 5px solid #f44336;
}

.room-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.toast-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}

.room-name {
  font-weight: 700;
  font-size: 13px;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sla-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  margin-top: 2px;
  width: fit-content;
}

.badge-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 2px;
}

.badge-warning {
  background-color: #fff3e0;
  color: #ff9800;
}

.badge-response {
  background-color: #fbe9e7;
  color: #ff5722;
}

.badge-resolution {
  background-color: #ffebee;
  color: #f44336;
}

.close-btn {
  border: none;
  background: transparent;
  color: #9e9e9e;
  font-size: 18px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.close-btn:hover {
  color: #424242;
}

/* Vue Transition Animation (Slide & Fade) */
.toast-list-enter-active,
.toast-list-leave-active {
  transition: all 0.3s ease;
}

.toast-list-enter {
  opacity: 0;
  transform: translateX(30px);
}

.toast-list-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.due-time-text {
  font-size: 11px;
  color: #e65100;
  font-weight: 600;
  margin-left: 4px;
}
</style>